import React from 'react'
import { Media } from 'react-bootstrap'
import ReactImageFallback from 'react-image-fallback'
import { Link } from 'react-router-dom'

import { guessThumbnailSrcFromUrl } from '../../../actions/profileViewActions'

const ProfileSectionLinkedContent = ({
  section,
  expanded,

  hideDescription
}) => {
  if (!section.additional) {
    return null
  }

  const defaultThumb = s => {
    //console.log(s)

    //console.log(isOccupation)
    if (s.thumbnail) {
      return (
        <ReactImageFallback
          src={s.thumbnail}
          fallbackImage={guessThumbnailSrcFromUrl(s.url)}
          alt={`Thumbnail for ${s.title}`}
          width={64}
          height={64}
          className="img-rounded"
        />
      )
    }

    const tn = guessThumbnailSrcFromUrl(s.url)

    if (tn) {
      return (
        <img
          className="img-rounded"
          width={64}
          height={64}
          src={tn}
          alt={`Thumbnail for ${s.title}`}
        />
      )
    }

    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
        <rect fill="#DDDDDD" x="0" y="0" width="64" height="64" rx="6" ry="6" />
        <text
          x="32"
          y="32"
          fontFamily="Verdana"
          fontSize="35"
          textAnchor="middle"
          alignmentBaseline="central">
        </text>
      </svg>
    )
  }

  if (expanded) {
    return (
      <div>
        {section.additional.map(s => (
          <Media key={`media.${s.url}`}>
            <Media.Left>
              <Link to={s.url}>{defaultThumb(s)}</Link>
            </Media.Left>
            <Media.Body>
              <Media.Heading>
                <Link to={s.url}>{s.title}</Link>
              </Media.Heading>
              {!hideDescription && <p>{s.description}</p>}
            </Media.Body>
          </Media>
        ))}
      </div>
    )
  }

  return (
    <ul className="list">
      {' '}
      {section.additional.map((s, idx) => (
        <li className="item" key={`additional-detail-${idx}`}>
          <Link to={s.url}>{s.title}</Link>
        </li>
      ))}{' '}
    </ul>
  )
}

export default ProfileSectionLinkedContent
